var map = {
	"./22444285_fashion_by_cowardrobertford_preview_1574777055660.mp4": "./src/assets/images/projectsassets/22444285_fashion_by_cowardrobertford_preview_1574777055660.mp4",
	"./Minor Changes_1576155867553.mp4": "./src/assets/images/projectsassets/Minor Changes_1576155867553.mp4",
	"./NMMA Advocacy Year-in-Review.docx.": "./src/assets/images/projectsassets/NMMA Advocacy Year-in-Review.docx.",
	"./Screenshot at Nov 09 17-20-19_1573299909415.png": "./src/assets/images/projectsassets/Screenshot at Nov 09 17-20-19_1573299909415.png",
	"./Wire Fraud Tips Video v2.docx.": "./src/assets/images/projectsassets/Wire Fraud Tips Video v2.docx.",
	"./bg-hover_1574684464791.png": "./src/assets/images/projectsassets/bg-hover_1574684464791.png",
	"./flower_pastel_pink_frame_background-removebg-preview_1573299909415.png": "./src/assets/images/projectsassets/flower_pastel_pink_frame_background-removebg-preview_1573299909415.png",
	"./tasklist_1576044751996.png": "./src/assets/images/projectsassets/tasklist_1576044751996.png",
	"./tasklist_1576155867553.png": "./src/assets/images/projectsassets/tasklist_1576155867553.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/projectsassets sync recursive ^\\.\\/.*$";